import React from "react";
import { Star, ShieldCheck, Zap, Award, Sparkles } from "lucide-react";

const CONFIG = {
  featured: { label: "Featured", icon: Award, cls: "bg-gold text-white" },
  top_rated: { label: "Top Rated", icon: Star, cls: "bg-gold-light text-gold-dark" },
  fast_response: { label: "Fast Response", icon: Zap, cls: "bg-lawn-light text-lawn-dark" },
  sponsored: { label: "Sponsored", icon: Sparkles, cls: "bg-gold-light text-gold-dark" },
  verified: { label: "Verified", icon: ShieldCheck, cls: "bg-lawn-light text-lawn-dark" },
};

export const ProviderBadges = ({ badges = [], size = "sm" }) => {
  if (!badges.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {badges.map((b) => {
        const c = CONFIG[b];
        if (!c) return null;
        const Icon = c.icon;
        return (
          <span
            key={b}
            data-testid={`badge-${b}`}
            className={`inline-flex items-center gap-1 rounded-full font-semibold ${c.cls} ${size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-3 py-1 text-xs"}`}
          >
            <Icon className="w-3 h-3" strokeWidth={2.5} />
            {c.label}
          </span>
        );
      })}
    </div>
  );
};

export const Stars = ({ rating = 0, count, className = "" }) => (
  <div className={`inline-flex items-center gap-1 ${className}`}>
    <div className="flex">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`w-4 h-4 ${i <= Math.round(rating) ? "fill-gold text-gold" : "text-gray-300"}`}
          strokeWidth={1.5}
        />
      ))}
    </div>
    <span className="text-sm font-semibold text-lawn-ink">{Number(rating).toFixed(1)}</span>
    {count !== undefined && <span className="text-sm text-muted-foreground">({count})</span>}
  </div>
);
